import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SetTargetUrlTextFieldWrapper = styled.div`
    padding: 0px 24px 16px;
    ${setFontVariant("caption")};
`;

export const SetTargetUrlBannerWrapper = styled.div`
    padding: 0 24px 16px;
    > div {
        padding: 14px;
        width: 322px;
        height: 8px;
    }
`;

export const BannerTagsIndicationContent = styled(LeftFlexRow)`
    ${setFontVariant("caption", colorsPalettes.carbon[400])};
    width: 100%;
    padding: 6px;
    background-color: ${colorsPalettes.bluegrey[200]};
    border-radius: 6px;
    gap: 6px;
`;
